export default "__VITE_ASSET__DLhLDWsx__"